(() => {
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const selector = '[data-njd-category],[data-njs-category],[data-wheel-category],[data-njp-link],[data-njp-parent],[data-njt-category],.njt-popular-art';
  const cache = new Map(), pending = new Map();
  const groupBatches = new WeakMap();
  let generation = 0, vehicle = '', timer;
  const tasks = [];
  let running = 0;
  const ttl = 60000;
  const storageKey = 'njt-category-counts-v110:' + (new URL(location.href).searchParams.get('preview_theme_id') || 'store');
  try {
    const entries = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    for (const [key, hit] of entries) {
      if (hit && Number.isInteger(hit.count) && hit.count >= 0 && Date.now() - hit.at < ttl) cache.set(key, hit);
    }
  } catch (_) {}
  let persistTimer;
  function persistCounts() {
    clearTimeout(persistTimer);
    persistTimer = setTimeout(() => {
      const entries = [...cache].filter(([,hit]) => Number.isInteger(hit.count) && hit.count >= 0 && Date.now() - hit.at < ttl).slice(-300);
      try { sessionStorage.setItem(storageKey, JSON.stringify(entries)); } catch (_) {}
    }, 100);
  }
  function currentVehicle() {
    const url = new URL(location.href);
    const selected = url.searchParams.get(vehicleKey);
    if (selected || url.pathname.includes('/collections/')) return selected || '';
    try { return JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null')?.vehicleName || ''; }
    catch (_) { return ''; }
  }
  function mark(link, empty) {
    link.toggleAttribute('data-njt-no-match', empty);
    // Remove the full homepage tile, including its border, at every screen size.
    if (link.matches('.njt-popular-art')) link.closest('.njt-popular-card')?.toggleAttribute('data-njt-no-match', empty);
    const slide = link.closest('.swiper-slide');
    if (slide && link.matches('[data-njt-category]')) {
      slide.toggleAttribute('data-njt-no-match', empty);
    }
  }
  function pump() {
    while (running < 4 && tasks.length) {
      const task = tasks.shift(); running++;
      task().finally(() => { running--; pump(); });
    }
  }
  function count(path, selected) {
    const key = selected + '|' + path;
    const hit = cache.get(key);
    if (hit && Date.now() - hit.at < ttl) return Promise.resolve(hit.count);
    if (pending.has(key)) return pending.get(key);
    const promise = new Promise(resolve => {
      tasks.push(async () => {
        if (selected !== currentVehicle()) { pending.delete(key); resolve(null); return; }
        let result = null;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(path, location.origin);
          url.search = '';
          url.searchParams.set(vehicleKey, selected);
          url.searchParams.set('section_id', 'njt-category-availability');
          const current = new URL(location.href);
          ['preview_theme_id','_fd','pb'].forEach(k => { if (current.searchParams.has(k)) url.searchParams.set(k,current.searchParams.get(k)); });
          const response = await fetch(url, {signal:controller.signal});
          if (!response.ok) throw new Error('Unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.querySelector('[data-njt-category-availability]')?.textContent || 'null');
          if (data && Number.isInteger(data.count) && data.count >= 0 && (data.count === 0 || data.vehicle === selected)) result = data.count;
        } catch (_) { /* Keep navigation available on errors or unsupported filters. */ }
        clearTimeout(timeout);
        cache.set(key, {count: result, at: Date.now()});
        if (result !== null) persistCounts();
        pending.delete(key); resolve(result);
      });
    });
    pending.set(key,promise); pump(); return promise;
  }
  function arrange() {
    document.querySelectorAll('.swiper').forEach(slider => {
      if (slider.querySelector('[data-njt-category]')) slider.swiper?.update();
    });
    document.querySelectorAll('.njt-popular-grid').forEach(grid => {
      const cards = [...grid.querySelectorAll('.njt-popular-card')];
      cards.forEach(card => card.classList.remove('njt-mobile-last-wide'));
      const visible = cards.filter(card => !card.hasAttribute('data-njt-inactive') && !card.hasAttribute('data-njt-no-match'));
      if (visible.length % 2) visible[visible.length - 1]?.classList.add('njt-mobile-last-wide');
    });
    document.querySelectorAll('.njd-primary,.njs-primary').forEach(row => {
      const n = [...row.querySelectorAll('a')].filter(a => !a.hasAttribute('data-njt-no-match')).length;
      row.style.gridTemplateColumns = `repeat(${Math.max(1,n)},minmax(0,1fr))`;
    });
    document.querySelectorAll('.njd-more,.njs-more,.njt-wheels__more-parts').forEach(menu => {
      const links = [...menu.querySelectorAll('a')];
      menu.toggleAttribute('data-njt-no-match', links.length > 0 && links.every(a => a.hasAttribute('data-njt-no-match')));
    });
    document.querySelectorAll('njt-parts-menu').forEach(menu => {
      const parents = [...menu.querySelectorAll('[data-njp-parent]')].filter(a => !a.hasAttribute('data-njt-no-match'));
      const rows = Math.max(1,Math.ceil(parents.length/2));
      menu.querySelector('.njp-dialog')?.style.setProperty('--njp-rows',rows);
      parents.forEach((p,i) => {
        p.style.setProperty('--njp-row',i%rows+1);
        p.style.setProperty('--njp-column',i<rows?1:2);
        p.classList.toggle('njp-second-column',i>=rows);
      });
    });
  }
  function scan() {
    const next = currentVehicle();
    if (next !== vehicle) {
      vehicle = next; generation++;
      document.querySelectorAll('[data-njt-no-match]').forEach(el => el.removeAttribute('data-njt-no-match'));
      arrange();
    }
    const name = next.toUpperCase().replace(/[-_]/g, ' ');
    const sport = /BRONCO\s*SPORT/.test(name);
    const bronco = /BRONCO/.test(name) && !sport;
    const gladiator = /GLADIATOR|\bJT\b/.test(name);
    const wrangler = /WRANGLER|\b(?:JKU?|JLU?|TJ|YJ|CJ7)\b/.test(name);
    const runner = /4\s*RUNNER/.test(name);
    const pickup = !gladiator && /\b(?:CANYON|COLORADO|SILVERADO\s?\d*|SIERRA\s?\d*|F\s?150|F\s?250|F\s?350|RANGER|MAVERICK|RAM\s?(?:1500|2500|3500)|FRONTIER|TITAN|TACOMA|TUNDRA|EV PICK UP)\b/.test(name);
    const rules = {
      'all': true,
      'pickup': pickup,
      'soft-top': !next || wrangler || gladiator || bronco,
      'bed-cover': !next || pickup || gladiator,
      'winch': !next || wrangler || gladiator || bronco || sport,
      'camping': !next || wrangler || gladiator || bronco || runner,
      'vents': !next || wrangler || bronco || runner
    };
    document.querySelectorAll('[data-njt-vehicle-tile]').forEach(tile => {
      tile.toggleAttribute('data-njt-inactive', rules[tile.dataset.njtVehicleTile] === false);
    });
    const campPosition = runner ? '66.6667% 0%' : gladiator ? '0% 100%' : bronco ? '33.3333% 100%' : wrangler ? '100% 0%' : '33.3333% 0%';
    document.querySelectorAll('.njt-v87-camp-scene').forEach(scene => scene.style.setProperty('--njt-v87-position', campPosition));
    arrange();
    if (!vehicle) return;
    const selected = vehicle, version = generation;
    const groups = new Map();
    document.querySelectorAll(selector).forEach(link => {
      // Check collection tabs immediately; load large menu branches only when opened.
      if (link.closest('dialog:not([open]),[data-njp-sub][hidden],[data-njt-inactive]')) return;
      const raw = link.dataset.parentPath || link.getAttribute('href');
      if (!raw) return;
      let url;
      try { url = new URL(raw,location.origin); } catch (_) { return; }
      if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return;
      const group = link.closest('.njt-popular-grid,.njd-primary,.njs-primary,.njd-more,.njs-more,.njt-wheels__more-parts,.njp-dialog,.swiper') || link.parentElement;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push({link, path:url.pathname});
    });
    const ordered = [...groups].sort(([a], [b]) => Number(b.matches('.njt-popular-grid')) - Number(a.matches('.njt-popular-grid')));
    ordered.forEach(([group, entries]) => {
      const previous = groupBatches.get(group);
      if (previous && !previous.done && previous.version === version && previous.entries.length === entries.length && entries.every((entry, i) => entry.link === previous.entries[i].link && entry.path === previous.entries[i].path)) return;
      const batch = {version, entries, done:false};
      groupBatches.set(group, batch);
      Promise.all(entries.map(entry => count(entry.path, selected))).then(counts => {
        requestAnimationFrame(() => {
          if (generation !== version || groupBatches.get(group) !== batch) return;
          entries.forEach(({link}, i) => { if (link.isConnected) mark(link, counts[i] === 0); });
          batch.done = true;
          arrange();
        });
      });
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(scan,50); }
  function init() {
    document.addEventListener('njt:vehicle-state',schedule);
    window.addEventListener('popstate',schedule);
    window.addEventListener('focus',schedule);
    window.addEventListener('storage',schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    setInterval(() => { if (!document.hidden) schedule(); }, ttl);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','hidden'],childList:true});
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

